import { themeStyle } from '@src/theming';

import CloseIcon from '../Icon/CloseIcon';
import { H6, H7 } from '../Typography';

import { CloseIconWrapper, TagContainer } from './styles';
import { TagProps } from './types';

const iconTheme = {
  color: themeStyle.varInkMedium,
  activeDefaultColor: themeStyle.varInkMedium,
  activeColor: themeStyle.varInkMedium,
};

const Tag: React.FC<TagProps> = ({
  text,
  round = 'full',
  size = 's',
  maxWidth = '270px',
  onClick,
  onClose,
  isActive = false,
  dataTestId,
}) => {
  const isHoverable = !!onClick && !isActive;
  const Text = size === 's' ? H7 : H6;
  const iconHeight = size === 's' ? '10px' : '12px';

  return (
    <TagContainer
      data-testid={dataTestId}
      isActive={isActive}
      isHoverable={isHoverable}
      maxWidth={maxWidth}
      round={round}
      size={size}
      onClick={onClick}
    >
      <Text noTextOverflow>{text}</Text>
      {!!onClose && (
        <CloseIconWrapper
          data-testid={`${dataTestId}-close-icon`}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <CloseIcon height={iconHeight} theme={iconTheme} />
        </CloseIconWrapper>
      )}
    </TagContainer>
  );
};

export default Tag;
